module.exports = __webpack_public_path__ + "img/Engagement_Moderately_Engaged_32@2x.79d1722f.png";